import { AuthenticateWithRedirectCallback } from "@clerk/clerk-react";
import { useEffect } from "react";
import { useLocation } from "wouter";

const SSOCallbackPage = () => {
  const [, setLocation] = useLocation();

  useEffect(() => {
    // Clerk will handle auth first,
    // then redirect using URLs you passed to <SignUp />
    console.log("SSO Callback: Waiting for Clerk authentication");
  }, []);

  return (
    <AuthenticateWithRedirectCallback
      afterSignInUrl="/dashboard"
      afterSignUpUrl="/onboarding/step-1"
      signInFallbackRedirectUrl="/sign-in"
      signUpFallbackRedirectUrl="/onboarding/step-1"
    />
  );
};

export default SSOCallbackPage;
